import { createSelector } from '@reduxjs/toolkit';

import type { IState } from '@/Module/Store/Model';
import { subscriptionsV2UserSelectAll } from '@/Module/Subscription/Store/Selector/index';

export const selectedSubscriptionV2UserActiveSelector = createSelector(
  [(state: IState) => subscriptionsV2UserSelectAll(state)],
  list => {
    return list.filter(item => item?.remainingDays > 0);
  },
);
